import React from 'react';

function ItineraryPage() {

  return (
    <div></div>
  );
}

export default ItineraryPage;
